import React from 'react';
import PropTypes from 'prop-types';

import {
    ProgressBar,
} from 'react-bootstrap';

export default class ProgressBarAutoRun extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            progress:25,
        };
    }

    componentDidMount = () => {
        this.setState({progress:this.props.progress})
        this.myInterval = setInterval(()=>{
          if (this.state.progress < 100) {
              this.setState({ progress: this.state.progress + 25 });
          } else if (this.state.progress >= 100){
              clearInterval(this.myInterval);
          }
        }, 250);
    }

    render() {
        return (
            <ProgressBar bsStyle={this.props.bsStyle} now={this.state.progress}/>
        );
    }
}

ProgressBarAutoRun.propTypes = {
    progress: PropTypes.node,
    bsStyle: PropTypes.node,

};



// WEBPACK FOOTER //
// ./src/components/helpers/progress_bar/progress_bar.js